import React from "react";

// styles
import useStyles from "./styles";

// import Swiper core and required components
import SwiperCore, {
  Navigation,
  Pagination,
  Scrollbar,
  Mousewheel,
  Autoplay,
  A11y,
} from "swiper";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";
import "swiper/components/pagination/pagination.scss";
import "swiper/components/scrollbar/scrollbar.scss";

// context
import { useHomeInfo } from "../../useGlobal";

import { getOptimizedImgUrl } from "../../utils/common";

// import './custom.css'

// install Swiper components
SwiperCore.use([Navigation, Pagination, Scrollbar, Mousewheel, Autoplay, A11y]);

export default function PagSwiper (props) {
  const classes = useStyles();
  const { banners } = useHomeInfo();
  return (
    <div className={classes.themeColor}>
      <Swiper
        key={`autoplay-${banners.length !== 1}`}
        initialSlide={1}
        spaceBetween={50}
        slidesPerView={1}
        navigation
        mousewheel
        pagination={{ clickable: true }}
        scrollbar={{ draggable: true }}
        autoplay={banners.length !== 1}
        loop={banners.length !== 1}
      >
        {banners.map(banner => (
          <SwiperSlide key={`banner-${banner.id}`}>
            <a href={banner.link ? banner.link : undefined} target='_blank'>
              <img
                src={getOptimizedImgUrl({ url: banner.image, ext: "webp" })}
                alt={`banner-${banner.id}`}
                className={classes.banner}
              />
            </a>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
